import React from 'react';
import styles from './CompanyInformations.module.sass';
import Card from '../../../../components/Card';
import TextInput from '../../../../components/TextInput';
import Dropdown from '../../../../components/Dropdown';

const CompanyInformations = ({ company, onCompanyChange, onDropdownChange }) => {
    const SECTOR_OPTIONS = [
        { value: 'Informatique/Numérique', title: 'Informatique/Numérique' },
        { value: 'Commerce/Vente', title: 'Commerce/Vente' },
        { value: 'Marketing/Communication', title: 'Marketing/Communication' },
        { value: 'Ressources Humaines', title: 'Ressources Humaines' },
        { value: 'Finance/Comptabilité', title: 'Finance/Comptabilité' },
        { value: 'Industrie/Production', title: 'Industrie/Production' },
        { value: 'Santé/Social', title: 'Santé/Social' },
        { value: 'Éducation/Formation', title: 'Éducation/Formation' },
        { value: 'BTP/Architecture', title: 'BTP/Architecture' },
        { value: 'Transport/Logistique', title: 'Transport/Logistique' },
        { value: 'Autre', title: 'Autre' }
    ];

    const COMPANY_SIZE_OPTIONS = [
        { value: '1-10', title: '1-10 employés' },
        { value: '11-50', title: '11-50 employés' },
        { value: '51-200', title: '51-200 employés' },
        { value: '201-500', title: '201-500 employés' },
        { value: '500+', title: 'Plus de 500 employés' }
    ];
    return (
        <Card className={styles.card} title="Informations de l'entreprise" classTitle="title-green">
            <div className={styles.group}>
                <TextInput
                    className={styles.field}
                    label="Nom de l'entreprise (raison sociale)"
                    name="name"
                    type="text"
                    value={company?.name || ''}
                    onChange={onCompanyChange}
                    required
                />
                <TextInput
                    className={styles.field}
                    label="Nom commercial (si différent)"
                    name="commercial_name"
                    type="text"
                    value={company?.commercial_name || ''}
                    onChange={onCompanyChange}
                />
                <div className={styles.field}>
                    <label>Secteur d'activité *</label>
                    <Dropdown
                        options={SECTOR_OPTIONS}
                        value={SECTOR_OPTIONS.find(opt => opt.value === company?.sector) || ''}
                        setValue={(option) => onDropdownChange('sector', option)}
                        placeholder="Sélectionner le secteur"
                    />
                </div>
                <TextInput
                    className={styles.field}
                    label="SIRET (ou N° TVA si étranger)"
                    name="siret"
                    type="text"
                    value={company?.siret || ''}
                    onChange={onCompanyChange}
                    required
                />
                 <TextInput
                    className={styles.field}
                    label="Site web"
                    name="website"
                    type="url"
                    value={company?.website || ''}
                    onChange={onCompanyChange}
                />
                <div className={styles.field}>
                    <label>Taille de l'entreprise *</label>
                    <Dropdown
                        options={COMPANY_SIZE_OPTIONS}
                        value={COMPANY_SIZE_OPTIONS.find(opt => opt.value === company?.company_size) || ''}
                        setValue={(option) => onDropdownChange('company_size', option)}
                        placeholder="Sélectionner la taille"
                    />
                </div>
                
            </div>
        </Card>
    );
};

export default CompanyInformations;